import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import AuthLayout from "../components/AuthLayout";
import Button from "../components/Button";
import TextField from "../components/TextField";
import { apiRequest } from "../api";
import styles from "./AuthForm.module.css";

export default function ForgotPasswordPage({ onNavigate }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  // The API answers the same whether or not the email belongs to an admin
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (sending) {
      return;
    }
    setSending(true);
    setError(null);
    try {
      await apiRequest("/api/auth/admin/forgot-password", { method: "POST", body: { email } });
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <AuthLayout title="Log in">
      <form className={styles.form} onSubmit={handleSubmit}>
        <button
          type="button"
          className={`${styles.back} d-inline-flex align-items-center align-self-start`}
          onClick={() => onNavigate("/login")}
        >
          <ArrowLeft size={18} strokeWidth={1.75} aria-hidden="true" />
          Reset password
        </button>
        <p className={styles.intro}>Enter your work email to receive the password reset link.</p>

        {sent ? (
          <p className={styles.notice} role="status">
            If an admin account exists for <strong>{email}</strong>, a reset link is on its way.
          </p>
        ) : null}

        <TextField
          label="Email"
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
            setSent(false);
          }}
        />
        {error ? (
          <p className={styles.error} role="alert">
            {error}
          </p>
        ) : null}
        <Button type="submit" disabled={sending}>
          {sending ? "Sending…" : sent ? "Resend link" : "Send reset link"}
        </Button>
      </form>
    </AuthLayout>
  );
}
